import en from '@/languages/langs/en-general.json'
import fi from '@/languages/langs/fi-general.json'

export const languages  = {
  en: en,
  fi: fi
}
